import { useAppSelector } from '_hooks';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface RoleGuardProps {
  children: React.ReactNode;
  requiredRoles: string[];
  fallbackPath?: string;
}

const RoleGuard: React.FC<RoleGuardProps> = ({
  children,
  requiredRoles,
  fallbackPath = '/',
}) => {
  // Get user data from Redux store
  const { accountDetails: accountDetailsState, isAuthenticated } =
    useAppSelector((state: any) => state.auth);

  // If user is not authenticated, redirect to sign in
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  // If user doesn't have account details yet, show loading or redirect
  if (!accountDetailsState?.roleKey) {
    return <Navigate to="/" replace />;
  }

  const userRole = accountDetailsState.roleKey;

  // Check if user has required role
  const hasRequiredRole = requiredRoles.includes(userRole);

  if (!hasRequiredRole) {
    // Redirect to fallback path or home if user doesn't have required role
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
